import {RBCheck} from "@ldw/roesberg";
import { WebDokuTreeNode } from '../models/webdoku-tree-node';
import { WebDokuTreeNodeDto } from '../dto/webdoku-tree-node-dto';

export class WebDokuTreeNodeFactory {
  static fromDTO(dtoList: WebDokuTreeNodeDto[]): WebDokuTreeNode[] {
    const list: WebDokuTreeNode[] = [];
    if (!RBCheck.isNullOrHasNoValues(dtoList)) {
      dtoList.forEach(dto => {
        const item = new WebDokuTreeNode();
        item.id = dto.id;
        item.text = dto.text;
        item.children = this.fromDTO(dto.children)
        list.push(item);
      })
    }
    return list;
  }
}
